// src/pages/LoginPage.tsx
import React from 'react';
import { Container } from '@mui/material';
import LoginModal from '../components/auth/LoginModal';

const LoginPage: React.FC = () => {
  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <LoginModal 
        open={true}
        onClose={() => window.history.back()}
      />
    </Container>
  );
};

export default LoginPage;